import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';

import { PartnerDepartmentsComponent } from 'src/app/pages/partner-departments/partner-departments.component';
import { OurPartnerDialogComponent } from 'src/app/components/utility/our-partner-dialog/our-partner-dialog.component';

const partnerDeptsRoutes: Routes = [
  { path: '', component: PartnerDepartmentsComponent },
];

@NgModule({
  declarations: [PartnerDepartmentsComponent, OurPartnerDialogComponent],
  imports: [
    RouterModule.forChild(partnerDeptsRoutes),
    CommonModule,
    SharedModule,
  ],
})
export class PartnerDeptsModule {}
